import { getFavouriteTypeConfig } from '@/utils/poi-utils'

export function allFavourites(state) {
    return state.favourites
}

export function defaultFavourites(state) {
    let favourites = [...state.favourites]
    // filter out home and work, as there are stored in separate fields
    favourites = favourites.filter(fav => !fav.id.includes('home') && !fav.id.includes('work'))
    return favourites
}

export function favouriteHome(state) {
    return state.favouriteHome
}

export function favouriteWork(state) {
    return state.favouriteWork
}

export function favouritesLists(state) {
    return state.favouritesLists
}

export function savedRoutes(state) {
    return state.savedRoutes
}

export function savedRoutesListOpen(state) {
    return state.savedRoutesListOpen
}

export function savedRouteClicked(state) {
    return state.savedRouteClicked
}

export function favouritePickerOpen(state) {
    return state.favouritePickerOpen
}

export function favouritePickerFieldIndex(state) {
    return state.favouritePickerFieldIndex
}

export function openFavouriteOverlayAfterLogin(state) {
    return state.openFavouriteOverlayAfterLogin
}

export function favouriteCategories(state) {
    const categories = []
    const allFavouriteCategories = state.savedFavouriteTypes
    allFavouriteCategories.forEach(poiCategory => {
        if(poiCategory) {
            const poiConfig = getFavouriteTypeConfig(poiCategory, true)
            const categoryExists = categories.find(category => category.value === poiConfig.value)
            if(poiConfig && !categoryExists) {
                categories.push({
                    value: poiConfig.value,
                    label: poiConfig.name
                })
            }
        }
    })
    if(allFavouriteCategories.includes('ADDRESS')) {
        categories.push({
            value: 'ADDRESS',
            label: 'Eigene Orte'
        })
    }
    return categories
}

export function routeTrafficAlerts(state) {
    return state.routeTrafficAlerts
}

export function searchInputType(state) {
    return state.searchInputType
}

export function isSavedRoute(state, rootState) {
    // if the active route matches the active transport mode, show the star icon as filled
    if(state.activeRouteSaved) {
        return rootState.activeTransportModeTab === state.activeRouteSaved.mode
    }
    
    const hasSavedRouteTime = rootState.savedRouteTime;
    const hasSavedRouteSettings = rootState.savedRouteSettingsActive;
    const savedRouteModeMatches =
        rootState.activeTransportModeTab === state.savedRouteInfo.mode;
    let savedRouteWaypointsMatch = true
    for(let i = 0; i < rootState.routeWaypoints.length; i++) {
        const routeWaypoint = rootState.routeWaypoints[i]
        const savedRouteWaypoint = state.savedRouteInfo.waypoints && state.savedRouteInfo.waypoints[i] ? state.savedRouteInfo.waypoints[i] : false
        if(!savedRouteWaypoint) {
            savedRouteWaypointsMatch = false
            break;
        } else if(routeWaypoint.id !== savedRouteWaypoint.id) {
            savedRouteWaypointsMatch = false
            break;
        }
    }

    return (
        hasSavedRouteTime &&
        hasSavedRouteSettings &&
        savedRouteModeMatches &&
        savedRouteWaypointsMatch
    );
}

export function activeRouteSaved(state) {
    return state.activeRouteSaved
}

export function savedRouteInfo(state) {
    return state.savedRouteInfo;
}